(() => {
  'use strict';

  const FORM_ID = '1105194';
  const STYLE_ID = `zv-contact-native-shadow-${FORM_ID}`;
  const ROOT_SELECTOR = [
    `.zv-contact-native-form [data-form-root][data-forms-id="forms-root-${FORM_ID}"]`,
    `.zv-contact-native-form [data-forms-id="forms-root-${FORM_ID}"]`
  ].join(',');
  const EMBED_SELECTOR = 'form-embed, shopify-forms-embed';
  const PRIMARY_CONTROL_SELECTOR = [
    'input:not([type="hidden"]):not([type="submit"]):not([type="button"]):not([type="checkbox"]):not([type="radio"])',
    'textarea',
    'select'
  ].join(',');
  const SECONDARY_CONTROL_SELECTOR = [
    '[role="combobox"]',
    'button[aria-expanded]:not([type="submit"])',
    'input[type="hidden"][data-testid]',
    'input[type="hidden"][name]'
  ].join(',');
  const REQUIRED_FIELDS = ['name', 'email', 'phone', 'subject', 'order', 'message'];
  const MANDATORY_FIELDS = new Set(['name', 'email', 'phone', 'message']);
  const FIELD_LABELS = {
    name: 'Voor- en achternaam',
    email: 'E-mailadres',
    phone: 'Telefoonnummer',
    subject: 'Onderwerp',
    order: 'Ordernummer/serienummer',
    message: 'Bericht'
  };
  const DISPLAY_FIELD_LABELS = {
    name: window.ZinVoltI18n.t("full_name_6837a4"),
    email: window.ZinVoltI18n.t("email_address_f72754"),
    phone: window.ZinVoltI18n.t("phone_number_617829"),
    subject: window.ZinVoltI18n.t("subject_669b81"),
    order: window.ZinVoltI18n.t("order_serial_number_b601e2"),
    message: window.ZinVoltI18n.t("message_bb5597"),
  };
  const PLACEHOLDERS = {
    name: 'Jan de Vries',
    email: 'jan.devries@voorbeeld.nl',
    phone: '06 12 34 56 78',
    order: 'ZVG011026000000',
    message: 'Vertel kort waar we je mee kunnen helpen'
  };
  const SUBJECT_OPTIONS = [
    'Vraag over bestelling',
    'Vraag over levering',
    'Vraag over installatie',
    'Vraag over de app',
    'Andere vraag',
    'Question about an order',
    'Question about delivery',
    'Question about installation',
    'Question about the app',
    'Other question',
    'Order enquiry',
    'Delivery enquiry',
    'Installation help',
    'App support'
  ];
  const TECHNICAL_FIELD_ALIASES = new Set([
    'event id',
    'eventid',
    'fbp',
    'fbc',
    'client user agent',
    'clientuseragent'
  ]);

  const SHADOW_CSS = `
    :host {
      display: block !important;
      width: 100% !important;
      max-width: 100% !important;
      min-width: 0 !important;
      overflow: visible !important;
      --inline-container-max-width: 100% !important;
      --form-field-border-radius: 14px !important;
      --button-border-radius: 999px !important;
    }

    #app-embed,
    section[data-testid="form-container"] {
      box-sizing: border-box !important;
      width: 100% !important;
      max-width: 100% !important;
      min-width: 0 !important;
      margin: 0 !important;
      padding: 0 !important;
      background: transparent !important;
      overflow: visible !important;
    }

    #form-container-ref,
    #form-container-ref > section,
    #form-container-ref > section > section[role="dialog"][data-sizing="form-wrapper"],
    section[role="dialog"][data-sizing="form-wrapper"] {
      box-sizing: border-box !important;
      width: 100% !important;
      max-width: 100% !important;
      min-width: 0 !important;
      margin: 0 !important;
      overflow: visible !important;
    }

    .zv-native-form-title {
      display: none !important;
    }

    form.zv-native-contact-form {
      box-sizing: border-box !important;
      display: grid !important;
      width: 100% !important;
      max-width: 100% !important;
      min-width: 0 !important;
      gap: 20px !important;
      margin: 0 !important;
      padding: 0 !important;
      color: #0d1710 !important;
      font-family: Poppins, Arial, sans-serif !important;
      overflow: visible !important;
    }

    form.zv-native-contact-form,
    form.zv-native-contact-form * {
      box-sizing: border-box !important;
    }

    .zv-native-grid {
      position: relative !important;
      display: grid !important;
      grid-template-columns: repeat(2, minmax(0, 1fr)) !important;
      grid-template-areas:
        "name email"
        "phone subject"
        "order order"
        "message message" !important;
      column-gap: 18px !important;
      row-gap: 20px !important;
      width: 100% !important;
      max-width: 100% !important;
      min-width: 0 !important;
      margin: 0 !important;
      padding: 0 3px 0 0 !important;
      overflow: visible !important;
    }

    .zv-native-grid-contents {
      display: contents !important;
      max-width: 100% !important;
      min-width: 0 !important;
      overflow: visible !important;
    }

    .zv-native-grid-utility,
    .zv-native-technical-field {
      position: absolute !important;
      inset: auto !important;
      display: block !important;
      width: 1px !important;
      min-width: 1px !important;
      max-width: 1px !important;
      height: 1px !important;
      min-height: 1px !important;
      max-height: 1px !important;
      margin: -1px !important;
      padding: 0 !important;
      overflow: hidden !important;
      clip: rect(0 0 0 0) !important;
      clip-path: inset(50%) !important;
      white-space: nowrap !important;
      visibility: hidden !important;
      opacity: 0 !important;
      border: 0 !important;
      pointer-events: none !important;
    }

    form.zv-native-contact-form shop-lead-capture {
      position: absolute !important;
      width: 1px !important;
      height: 1px !important;
      overflow: hidden !important;
      opacity: 0 !important;
      pointer-events: none !important;
    }

    form.zv-native-contact-form > [role="alert"],
    form.zv-native-contact-form > [data-testid*="error"] {
      grid-column: 1 / -1 !important;
    }

    .zv-native-field {
      box-sizing: border-box !important;
      display: grid !important;
      grid-template-columns: minmax(0, 1fr) !important;
      align-content: start !important;
      min-width: 0 !important;
      max-width: 100% !important;
      height: auto !important;
      max-height: none !important;
      gap: 8px !important;
      margin: 0 !important;
      padding: 0 !important;
      border: 0 !important;
      outline: 0 !important;
      background: transparent !important;
      box-shadow: none !important;
      overflow: visible !important;
    }

    .zv-native-field[data-zv-native-field="name"] { grid-area: name !important; }
    .zv-native-field[data-zv-native-field="email"] { grid-area: email !important; }
    .zv-native-field[data-zv-native-field="phone"] { grid-area: phone !important; }
    .zv-native-field[data-zv-native-field="subject"] { grid-area: subject !important; }
    .zv-native-field[data-zv-native-field="order"] { grid-area: order !important; }
    .zv-native-field[data-zv-native-field="message"] {
      position: relative !important;
      isolation: isolate !important;
      grid-area: message !important;
    }

    .zv-native-label,
    .zv-native-display-label {
      position: relative !important;
      inset: auto !important;
      z-index: 3 !important;
      display: block !important;
      order: -1 !important;
      box-sizing: border-box !important;
      width: auto !important;
      height: auto !important;
      min-width: 0 !important;
      min-height: 0 !important;
      margin: 0 !important;
      padding: 0 !important;
      overflow: visible !important;
      clip: auto !important;
      clip-path: none !important;
      transform: none !important;
      white-space: normal !important;
      opacity: 1 !important;
      color: #0d1710 !important;
      background: transparent !important;
      font-family: Poppins, Arial, sans-serif !important;
      font-size: 13.5px !important;
      font-weight: 700 !important;
      line-height: 1.2 !important;
      letter-spacing: normal !important;
      text-transform: none !important;
      pointer-events: none !important;
    }

    .zv-native-label--required::after,
    .zv-native-display-label--required::after {
      content: ' *';
      color: #65a900;
    }

    .zv-native-source-label {
      position: absolute !important;
      width: 1px !important;
      height: 1px !important;
      margin: -1px !important;
      padding: 0 !important;
      overflow: hidden !important;
      clip: rect(0 0 0 0) !important;
      clip-path: inset(50%) !important;
      white-space: nowrap !important;
      border: 0 !important;
    }

    #app-embed form.zv-native-contact-form .zv-native-source-label,
    #app-embed form.zv-native-contact-form .zv-native-source-caption {
      position: absolute !important;
      width: 1px !important;
      height: 1px !important;
      margin: -1px !important;
      padding: 0 !important;
      overflow: hidden !important;
      clip: rect(0 0 0 0) !important;
      clip-path: inset(50%) !important;
      white-space: nowrap !important;
      border: 0 !important;
      opacity: 1 !important;
      pointer-events: none !important;
    }

    /* Shopify toggles its floating-label class immediately after focus/input.
       Match the stable field handles as well, so those labels can never flash
       over the border while the presentation observer catches up. */
    #app-embed form.zv-native-contact-form label[for="custom#ordernummer"],
    #app-embed form.zv-native-contact-form label[for="custom#bericht"] {
      position: absolute !important;
      inset: auto !important;
      width: 1px !important;
      height: 1px !important;
      min-width: 0 !important;
      min-height: 0 !important;
      margin: -1px !important;
      padding: 0 !important;
      overflow: hidden !important;
      clip: rect(0 0 0 0) !important;
      clip-path: inset(50%) !important;
      transform: none !important;
      white-space: nowrap !important;
      border: 0 !important;
      background: transparent !important;
      box-shadow: none !important;
      pointer-events: none !important;
    }

    .zv-native-label--wraps-control {
      display: grid !important;
      width: 100% !important;
      gap: 8px !important;
    }

    .zv-native-source-label--wraps-control {
      position: static !important;
      display: grid !important;
      grid-template-columns: minmax(0, 1fr) !important;
      gap: 8px !important;
      width: 100% !important;
      height: auto !important;
      min-width: 0 !important;
      min-height: 0 !important;
      margin: 0 !important;
      padding: 0 !important;
      overflow: visible !important;
      clip: auto !important;
      clip-path: none !important;
      color: transparent !important;
      font-size: 0 !important;
      line-height: 0 !important;
      white-space: normal !important;
      border: 0 !important;
    }

    .zv-native-caption-container {
      color: transparent !important;
      -webkit-text-fill-color: transparent !important;
      font-size: 0 !important;
      line-height: 0 !important;
    }

    .zv-native-source-label--wraps-control::before,
    .zv-native-source-label--wraps-control::after {
      content: none !important;
      display: none !important;
    }

    .zv-native-contact-form .zv-native-source-caption {
      position: absolute !important;
      width: 1px !important;
      height: 1px !important;
      margin: -1px !important;
      padding: 0 !important;
      overflow: hidden !important;
      clip: rect(0 0 0 0) !important;
      clip-path: inset(50%) !important;
      white-space: nowrap !important;
      border: 0 !important;
      pointer-events: none !important;
    }

    .zv-native-control-path {
      box-sizing: border-box !important;
      width: auto !important;
      max-width: 100% !important;
      min-width: 0 !important;
      border: 0 !important;
      outline: 0 !important;
      background: transparent !important;
      box-shadow: none !important;
      overflow: visible !important;
    }

    .zv-native-source-label--wraps-control [role="alert"],
    .zv-native-source-label--wraps-control [data-testid*="error"],
    .zv-native-source-label--wraps-control [aria-live] {
      color: #8a3028 !important;
      font-size: 12px !important;
      line-height: 1.35 !important;
    }

    .zv-native-source-label--wraps-control input,
    .zv-native-source-label--wraps-control textarea,
    .zv-native-source-label--wraps-control select,
    .zv-native-source-label--wraps-control button,
    .zv-native-source-label--wraps-control [role="combobox"],
    .zv-native-caption-container input,
    .zv-native-caption-container textarea,
    .zv-native-caption-container select,
    .zv-native-caption-container button,
    .zv-native-caption-container [role="combobox"] {
      color: #0d1710 !important;
      -webkit-text-fill-color: #0d1710 !important;
      font-family: Poppins, Arial, sans-serif !important;
      font-size: 15px !important;
      line-height: 1.2 !important;
    }

    .zv-native-field input:not([type="hidden"]):not([type="submit"]):not([type="button"]),
    .zv-native-field textarea,
    .zv-native-field select,
    .zv-native-field button[aria-expanded] {
      box-sizing: border-box !important;
      width: 100% !important;
      max-width: 100% !important;
      min-width: 0 !important;
      min-height: 52px !important;
      margin: 0 !important;
      border: 1px solid rgba(17, 24, 17, .18) !important;
      border-radius: 14px !important;
      outline: 0 !important;
      background-color: #f8faf5 !important;
      color: #0d1710 !important;
      box-shadow: none !important;
      font-family: Poppins, Arial, sans-serif !important;
      font-size: 15px !important;
      font-weight: 300 !important;
      line-height: 1.2 !important;
      letter-spacing: normal !important;
      transition: border-color .18s ease, box-shadow .18s ease, background-color .18s ease !important;
    }

    .zv-native-field input:not([type="hidden"]):not([type="submit"]):not([type="button"]),
    .zv-native-field select,
    .zv-native-field button[aria-expanded] {
      height: 52px !important;
      padding: 0 18px !important;
    }

    .zv-native-field textarea {
      display: block !important;
      min-height: 156px !important;
      padding: 17px 18px !important;
      resize: vertical !important;
      line-height: 1.5 !important;
    }

    /* Draw the message outline on the stable field wrapper. Shopify places a
       floating label on top of its textarea border while focus/value state is
       changing; that can visually erase the long middle part of the top edge.
       This presentation-only outline remains continuous in every state and
       never touches the textarea value or submission behaviour. */
    .zv-native-field[data-zv-native-field="message"] textarea {
      position: relative !important;
      z-index: 1 !important;
      border-color: transparent !important;
      box-shadow: none !important;
    }

    .zv-native-field[data-zv-native-field="message"]::after {
      content: '' !important;
      position: absolute !important;
      z-index: 2 !important;
      top: 24.2px !important;
      right: 0 !important;
      bottom: 0 !important;
      left: 0 !important;
      border: 1px solid rgba(17, 24, 17, .18) !important;
      border-radius: 14px !important;
      background: transparent !important;
      box-shadow: none !important;
      pointer-events: none !important;
    }

    .zv-native-field[data-zv-native-field="message"]:focus-within::after {
      border-color: rgba(164, 240, 72, .95) !important;
      box-shadow: inset 0 0 0 1px rgba(164, 240, 72, .95) !important;
    }

    .zv-native-field[data-zv-native-field="message"]:has(textarea[aria-invalid="true"])::after {
      border-color: #a12e25 !important;
      box-shadow: inset 0 0 0 1px rgba(161, 46, 37, .16) !important;
    }

    .zv-native-field input::placeholder,
    .zv-native-field textarea::placeholder {
      color: #657067 !important;
      opacity: 1 !important;
      font-family: Poppins, Arial, sans-serif !important;
      font-size: 13.5px !important;
      line-height: 1.4 !important;
      letter-spacing: normal !important;
    }

    .zv-native-field select {
      appearance: none !important;
      padding-right: 42px !important;
      background-image:
        linear-gradient(45deg, transparent 50%, #0d1710 50%),
        linear-gradient(135deg, #0d1710 50%, transparent 50%) !important;
      background-position:
        calc(100% - 22px) 23px,
        calc(100% - 16px) 23px !important;
      background-repeat: no-repeat !important;
      background-size: 6px 6px, 6px 6px !important;
    }

    .zv-native-field input:focus,
    .zv-native-field textarea:focus,
    .zv-native-field select:focus,
    .zv-native-field button[aria-expanded]:focus-visible {
      border-color: rgba(164, 240, 72, .95) !important;
      outline: 0 !important;
      background-color: #ffffff !important;
      box-shadow: inset 0 0 0 2px rgba(164, 240, 72, .95) !important;
    }

    .zv-native-field[data-zv-native-field="subject"] {
      position: relative !important;
      z-index: 6 !important;
      overflow: visible !important;
    }

    .zv-native-subject-trigger {
      position: relative !important;
      display: flex !important;
      align-items: center !important;
      justify-content: flex-start !important;
      gap: 8px !important;
      width: 100% !important;
      max-width: 100% !important;
      min-width: 0 !important;
      height: 52px !important;
      padding: 0 48px 0 18px !important;
      overflow: visible !important;
      color: #0d1710 !important;
      -webkit-text-fill-color: #0d1710 !important;
      font-family: Poppins, Arial, sans-serif !important;
      font-size: 15px !important;
      font-weight: 300 !important;
      line-height: 1.2 !important;
      text-align: left !important;
      white-space: normal !important;
    }

    .zv-native-subject-trigger > * {
      opacity: 0 !important;
      pointer-events: none !important;
    }

    .zv-native-subject-trigger .zv-native-subject-native-arrow {
      display: none !important;
    }

    .zv-native-subject-trigger::before {
      content: attr(data-zv-subject-value) !important;
      position: absolute !important;
      inset: 0 48px 0 18px !important;
      z-index: 2 !important;
      display: flex !important;
      align-items: center !important;
      min-width: 0 !important;
      overflow: hidden !important;
      color: #0d1710 !important;
      -webkit-text-fill-color: #0d1710 !important;
      font-family: Poppins, Arial, sans-serif !important;
      font-size: 15px !important;
      font-weight: 300 !important;
      line-height: 1.2 !important;
      text-align: left !important;
      text-overflow: ellipsis !important;
      white-space: nowrap !important;
      pointer-events: none !important;
    }

    .zv-native-subject-trigger::after {
      content: '' !important;
      position: absolute !important;
      top: 50% !important;
      right: 19px !important;
      display: block !important;
      width: 8px !important;
      height: 8px !important;
      margin: -6px 0 0 !important;
      border-right: 2px solid #0d1710 !important;
      border-bottom: 2px solid #0d1710 !important;
      transform: rotate(45deg) !important;
      pointer-events: none !important;
    }

    .zv-native-subject-select--backing,
    .zv-native-subject-auxiliary {
      position: absolute !important;
      inset: auto !important;
      width: 1px !important;
      height: 1px !important;
      min-width: 0 !important;
      min-height: 0 !important;
      margin: -1px !important;
      padding: 0 !important;
      border: 0 !important;
      overflow: hidden !important;
      clip: rect(0 0 0 0) !important;
      clip-path: inset(50%) !important;
      opacity: 0 !important;
      pointer-events: none !important;
    }

    #app-embed form.zv-native-contact-form
      .zv-native-field[data-zv-native-field="subject"] .zv-native-subject-trigger {
      display: flex !important;
      align-items: center !important;
      justify-content: flex-start !important;
      width: 100% !important;
      padding: 0 48px 0 18px !important;
      color: #0d1710 !important;
      -webkit-text-fill-color: #0d1710 !important;
      text-align: left !important;
    }

    .zv-native-subject-menu-shell,
    .zv-native-subject-listbox {
      box-sizing: border-box !important;
      max-height: none !important;
      height: auto !important;
      overflow: visible !important;
      overflow-y: visible !important;
      overscroll-behavior: auto !important;
    }

    .zv-native-subject-listbox {
      z-index: 30 !important;
    }

    .zv-native-subject-option {
      box-sizing: border-box !important;
      min-height: 44px !important;
      height: auto !important;
      padding: 10px 18px !important;
      color: #0d1710 !important;
      -webkit-text-fill-color: #0d1710 !important;
      font-family: Poppins, Arial, sans-serif !important;
      font-size: 15px !important;
      font-weight: 300 !important;
      line-height: 1.3 !important;
      white-space: normal !important;
    }

    .zv-native-subject-option:focus,
    .zv-native-subject-option:focus-visible,
    .zv-native-subject-option[aria-selected="true"] {
      border-radius: 12px !important;
      outline: 0 !important;
      box-shadow: inset 0 0 0 2px rgba(73, 151, 0, .95) !important;
    }

    .zv-native-phone-row {
      display: flex !important;
      align-items: stretch !important;
      gap: 8px !important;
      width: 100% !important;
      min-width: 0 !important;
    }

    .zv-native-phone-field-direct {
      grid-template-columns: auto minmax(0, 1fr) !important;
      column-gap: 8px !important;
    }

    .zv-native-phone-field-direct > .zv-native-display-label {
      grid-column: 1 / -1 !important;
    }

    .zv-native-phone-field-direct > .zv-native-phone-country-slot {
      grid-column: 1 !important;
    }

    .zv-native-phone-field-direct > .zv-native-phone-input-slot {
      grid-column: 2 !important;
    }

    .zv-native-phone-country-slot {
      flex: 0 0 auto !important;
      width: auto !important;
      min-width: 0 !important;
    }

    .zv-native-phone-input-slot {
      flex: 1 1 0 !important;
      width: auto !important;
      max-width: 100% !important;
      min-width: 0 !important;
    }

    .zv-native-phone-input-slot input,
    input.zv-native-phone-input-slot {
      width: 100% !important;
      max-width: 100% !important;
      min-width: 0 !important;
    }

    .zv-native-field[data-zv-native-field="phone"] button[aria-expanded] {
      flex: 0 0 auto !important;
      width: auto !important;
      min-width: 78px !important;
      padding-inline: 14px !important;
    }

    .zv-native-field[data-zv-native-field="phone"] input {
      flex: 1 1 auto !important;
    }

    .zv-native-submit-row {
      grid-column: 1 / -1 !important;
      display: flex !important;
      align-items: center !important;
      justify-content: flex-start !important;
      width: 100% !important;
      min-width: 0 !important;
      min-height: 48px !important;
      margin: 4px 0 0 !important;
      padding: 0 !important;
    }

    button.zv-native-submit-button {
      box-sizing: border-box !important;
      display: inline-flex !important;
      flex: 1 1 auto !important;
      align-items: center !important;
      justify-content: center !important;
      gap: 12px !important;
      width: 100% !important;
      min-width: 0 !important;
      max-width: 100% !important;
      min-height: 48px !important;
      height: 48px !important;
      margin: 0 !important;
      padding: 12px 22px !important;
      border: 1px solid #a4f048 !important;
      border-radius: 999px !important;
      background: #a4f048 !important;
      color: #0d1710 !important;
      box-shadow: none !important;
      font-family: Poppins, Arial, sans-serif !important;
      font-size: 14px !important;
      font-weight: 700 !important;
      line-height: 1 !important;
      letter-spacing: normal !important;
      white-space: nowrap !important;
      cursor: pointer !important;
    }

    #app-embed form.zv-native-contact-form .zv-native-submit-row button.zv-native-submit-button {
      flex: 1 1 auto !important;
      width: 100% !important;
      max-width: 100% !important;
    }

    button.zv-native-submit-button::after {
      content: '';
      display: block;
      width: 8px;
      height: 8px;
      border-top: 2px solid currentColor;
      border-right: 2px solid currentColor;
      transform: rotate(45deg);
      transform-origin: center;
    }

    button.zv-native-submit-button:hover {
      background: #96df3f !important;
      border-color: #96df3f !important;
    }

    button.zv-native-submit-button:focus-visible {
      outline: 0 !important;
      box-shadow: 0 0 0 5px rgba(164, 240, 72, .22) !important;
    }

    button.zv-native-submit-button:disabled {
      cursor: wait !important;
      opacity: .72 !important;
    }

    [data-testid="banner-success"].zv-native-success-banner {
      box-sizing: border-box !important;
      display: block !important;
      width: 100% !important;
      max-width: none !important;
      min-width: 0 !important;
      min-height: 0 !important;
      height: auto !important;
      margin: 0 !important;
      padding: 0 !important;
      border: 0 !important;
      border-radius: 0 !important;
      background: transparent !important;
      color: #0d1710 !important;
      box-shadow: none !important;
      font-family: Poppins, Arial, sans-serif !important;
    }

    .zv-native-success-original {
      display: none !important;
    }

    [data-zv-native-success-panel] {
      box-sizing: border-box !important;
      display: grid !important;
      grid-template-columns: auto minmax(0, 1fr) !important;
      gap: 8px 18px !important;
      width: 100% !important;
      min-width: 0 !important;
      padding: 22px !important;
      border: 1px solid rgba(17, 24, 17, .09) !important;
      border-radius: 22px !important;
      background: #f8faf5 !important;
      color: #0d1710 !important;
      box-shadow: none !important;
      font-family: Poppins, Arial, sans-serif !important;
    }

    .zv-native-success-icon {
      display: inline-flex !important;
      grid-row: 1 !important;
      align-items: center !important;
      justify-content: center !important;
      width: 38px !important;
      height: 38px !important;
      margin: 0 !important;
      border-radius: 999px !important;
      background: #a4f048 !important;
      color: #0d1710 !important;
      font-family: Arial, sans-serif !important;
      font-size: 22px !important;
      font-weight: 700 !important;
      line-height: 1 !important;
    }

    .zv-native-success-copy {
      display: grid !important;
      align-content: center !important;
      gap: 7px !important;
      min-width: 0 !important;
    }

    .zv-native-success-heading {
      margin: 0 !important;
      color: #0d1710 !important;
      font-family: Poppins, Arial, sans-serif !important;
      font-size: 24px !important;
      font-weight: 700 !important;
      line-height: 1.12 !important;
      letter-spacing: -.025em !important;
    }

    .zv-native-success-text {
      margin: 0 !important;
      color: #2f3d31 !important;
      font-family: Poppins, Arial, sans-serif !important;
      font-size: 15px !important;
      font-weight: 300 !important;
      line-height: 1.5 !important;
    }

    .zv-native-success-actions {
      display: flex !important;
      grid-column: 1 / -1 !important;
      grid-row: 2 !important;
      flex-wrap: wrap !important;
      gap: 10px !important;
      margin-top: 4px !important;
    }

    .zv-native-success-link {
      box-sizing: border-box !important;
      display: inline-flex !important;
      align-items: center !important;
      justify-content: center !important;
      gap: 14px !important;
      min-height: 48px !important;
      padding: 12px 22px !important;
      border: 1px solid rgba(17, 24, 17, .10) !important;
      border-radius: 999px !important;
      background: #ffffff !important;
      color: #0d1710 !important;
      font-family: Poppins, Arial, sans-serif !important;
      font-size: 14px !important;
      font-weight: 700 !important;
      line-height: 1.2 !important;
      text-align: center !important;
      text-decoration: none !important;
      box-shadow: none !important;
    }

    .zv-native-success-link--primary {
      border-color: #a4f048 !important;
      background: #a4f048 !important;
    }

    .zv-native-success-link::after {
      content: '';
      display: block;
      flex: 0 0 auto;
      width: 8px;
      height: 8px;
      border-top: 2px solid currentColor;
      border-right: 2px solid currentColor;
      transform: rotate(45deg);
    }

    .zv-native-success-link:hover {
      border-color: rgba(17, 24, 17, .22) !important;
    }

    .zv-native-success-link--primary:hover {
      border-color: #96df3f !important;
      background: #96df3f !important;
    }

    .zv-native-success-link:focus-visible {
      outline: 0 !important;
      box-shadow: 0 0 0 5px rgba(164, 240, 72, .22) !important;
    }

    #app-embed.zv-native-success-container,
    section[data-testid="form-container"].zv-native-success-container {
      min-height: 0 !important;
      height: auto !important;
    }

    @media (max-width: 989px) {
      .zv-native-grid {
        grid-template-columns: minmax(0, 1fr) !important;
        grid-template-areas:
          "name"
          "email"
          "phone"
          "subject"
          "order"
          "message" !important;
      }

      .zv-native-field {
        grid-column: 1 / -1 !important;
      }
    }

    @media (max-width: 749px) {
      .zv-native-field input:not([type="hidden"]):not([type="submit"]):not([type="button"]),
      .zv-native-field textarea,
      .zv-native-field select,
      .zv-native-field button[aria-expanded] {
        font-size: 16px !important;
      }

      .zv-native-field input::placeholder,
      .zv-native-field textarea::placeholder {
        font-size: 14px !important;
      }

      .zv-native-submit-row {
        align-items: stretch !important;
      }

      button.zv-native-submit-button {
        width: 100% !important;
        white-space: normal !important;
      }

      #app-embed form.zv-native-contact-form .zv-native-submit-row button.zv-native-submit-button {
        width: 100% !important;
      }

      .zv-native-success-actions {
        display: grid !important;
        grid-template-columns: minmax(0, 1fr) !important;
      }

      .zv-native-success-link {
        width: 100% !important;
      }
    }

    @media (max-width: 519px) {
      [data-zv-native-success-panel] {
        grid-template-columns: minmax(0, 1fr) !important;
        gap: 12px !important;
        padding: 20px !important;
      }

      .zv-native-success-icon {
        grid-row: auto !important;
        width: 38px !important;
        height: 38px !important;
        font-size: 22px !important;
      }

      .zv-native-success-actions {
        grid-column: 1 !important;
        grid-row: auto !important;
        margin-top: 4px !important;
      }
    }

    @media (prefers-reduced-motion: reduce) {
      .zv-native-field input,
      .zv-native-field textarea,
      .zv-native-field select,
      .zv-native-field button,
      button.zv-native-submit-button {
        transition: none !important;
      }
    }
    /* Homepage action styles also apply inside Shopify Forms' shadow root.
       Only presentation is shared; submission, validation and consent stay native. */
    button.zv-native-submit-button, .zv-native-success-link {
      height: var(--zv-button-height, 48px) !important;
      min-height: var(--zv-button-height, 48px) !important;
      max-height: var(--zv-button-height, 48px) !important;
      padding: 6px 22px !important;
      gap: 10px !important;
      border-radius: 999px !important;
      font-size: 14px !important;
      font-weight: 600 !important;
      line-height: 1.15 !important;
      letter-spacing: -.01em !important;
      white-space: normal !important;
    }
    button.zv-native-submit-button::after, .zv-native-success-link::after {
      content: '';
      display: none;
    }
    button.zv-native-submit-button::after, .zv-native-success-link--primary::after {
      content: '';
      display: block;
      position: static;
      width: 17px;
      height: 17px;
      flex: 0 0 17px;
      border: 0;
      background: currentColor;
      -webkit-mask: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24'%3E%3Cpath d='m8 4 8 8-8 8' fill='none' stroke='black' stroke-width='3' stroke-linecap='round' stroke-linejoin='round'/%3E%3C/svg%3E") center / contain no-repeat;
      mask: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24'%3E%3Cpath d='m8 4 8 8-8 8' fill='none' stroke='black' stroke-width='3' stroke-linecap='round' stroke-linejoin='round'/%3E%3C/svg%3E") center / contain no-repeat;
      transform: none;
    }
    button.zv-native-submit-button:hover, .zv-native-success-link--primary:hover {
      background: #b7ff5c !important;
      border-color: transparent !important;
    }

    .zv-native-success-link:not(.zv-native-success-link--primary) { border-color: rgba(13, 23, 16, .16) !important; }

  `;

  const shadowObservers = new WeakMap();
  let documentObserver;
  let scanFrame = 0;
  let pollTimer = 0;
  let pollDeadline = 0;

  const normalise = (value) => String(value || '')
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, ' ')
    .trim();

  const unique = (items) => [...new Set(items.filter(Boolean))];

  const copyFromOuter = (outer, name, fallback = '') => {
    const value = outer?.getAttribute?.(`data-zv-${name}`);
    return String(value || fallback || '').trim();
  };

  const topLevelBranch = (node, boundary) => {
    let branch = node;
    while (branch?.parentElement && branch.parentElement !== boundary) {
      branch = branch.parentElement;
    }
    return branch?.parentElement === boundary ? branch : null;
  };

  const markGridUtilities = (grid) => {
    grid.querySelectorAll('shop-lead-capture').forEach((capture) => {
      let branch = capture;
      while (branch.parentElement && branch.parentElement !== grid) {
        const parent = branch.parentElement;
        if (parent.matches('.zv-native-field') || parent.querySelector('.zv-native-field')) break;
        branch = parent;
      }
      if (!branch.matches('.zv-native-field') && !branch.querySelector('.zv-native-field')) {
        branch.classList.add('zv-native-grid-utility');
      }
    });
  };

  const nativeLabelAliases = (key, outer) => {
    const aliases = new Set([
      normalise(FIELD_LABELS[key]),
      normalise(copyFromOuter(outer, `label-${key}`, FIELD_LABELS[key])),
      normalise(PLACEHOLDERS[key]),
      normalise(copyFromOuter(outer, `placeholder-${key}`, PLACEHOLDERS[key]))
    ]);
    const common = {
      name: ['naam', 'first name', 'voornaam', 'name', 'full name', 'first and last name'],
      email: ['email', 'e mailadres', 'e mail address', 'email address'],
      phone: ['telefoonnummer', 'phone', 'phone number'],
      subject: ['onderwerp', 'subject'],
      order: ['ordernummer', 'serienummer', 'ordernummer serienummer', 'order number', 'serial number', 'order serial number', 'order number serial number'],
      message: ['bericht', 'message']
    };
    (common[key] || []).forEach((value) => aliases.add(normalise(value)));
    return aliases;
  };

  const cleanNativeCaption = (value) => normalise(value)
    .replace(/\b(required|verplicht|vereist|optional|optioneel)\b/g, ' ')
    .replace(/\s+/g, ' ')
    .trim();

  const isTechnicalFieldDescriptor = (descriptor) => {
    const words = normalise(descriptor);
    const compact = words.replace(/\s+/g, '');
    return TECHNICAL_FIELD_ALIASES.has(words)
      || TECHNICAL_FIELD_ALIASES.has(compact)
      || /(^|\s)(event id|fbp|fbc|client user agent)(\s|$)/.test(words)
      || /(^|\s)(eventid|clientuseragent)(\s|$)/.test(words);
  };

  const markTechnicalFields = (form, controls) => {
    const allControls = unique(controls);

    allControls.forEach((control) => {
      if (!isTechnicalFieldDescriptor(descriptorFor(control, form))) return;

      const wrapper = fieldWrapperFor(control, form, allControls);
      if (wrapper && wrapper !== form) wrapper.classList.add('zv-native-technical-field');

      labelsFor(control, form).forEach((label) => {
        if (!label || wrapper?.contains(label)) return;
        label.classList.add('zv-native-technical-field');
      });
    });
  };

  const markNativeCaptionText = (wrapper, key, outer) => {
    const aliases = nativeLabelAliases(key, outer);
    const elements = [wrapper, ...Array.from(wrapper.querySelectorAll('*'))];
    const matchedLabels = new Set();

    elements.forEach((element) => {
      if (
        element.closest('.zv-native-display-label')
        || element.closest('[role="alert"], [data-testid*="error"], [aria-live]')
        || element.closest('button, [role="combobox"]')
        || element.matches('input, textarea, select, option, script, style')
      ) return;

      const hasInteractiveDescendant = Boolean(element.querySelector(
        'input, textarea, select, button, [role="combobox"], [role="option"]'
      ));
      if (
        element.tagName === 'LABEL'
        && hasInteractiveDescendant
        && aliases.has(cleanNativeCaption(element.textContent))
      ) {
        matchedLabels.add(element);
      }
      if (
        element !== wrapper
        && hasInteractiveDescendant
        && aliases.has(cleanNativeCaption(element.textContent))
      ) {
        element.classList.add('zv-native-caption-container');
      }
      if (element === wrapper || hasInteractiveDescendant) return;
      if (!aliases.has(cleanNativeCaption(element.textContent))) return;

      element.classList.add('zv-native-source-caption');
      const label = element.closest('label');
      if (label) matchedLabels.add(label);
    });

    // Shopify can render the required asterisk as a separate text/span next
    // to its floating caption. Hide only that marker inside the same label;
    // our own bold display label supplies the visible required indicator.
    matchedLabels.forEach((label) => {
      label.querySelectorAll('*').forEach((element) => {
        if (element.querySelector('input, textarea, select, button, [role="combobox"]')) return;
        if (/^\s*\*\s*$/.test(String(element.textContent || ''))) {
          element.classList.add('zv-native-source-caption');
        }
      });
    });
  };

  const markControlPath = (wrapper, control) => {
    let node = control.parentElement;
    while (node && node !== wrapper) {
      node.classList.add('zv-native-control-path');
      node = node.parentElement;
    }
  };

  const subjectTextMatches = (value) => {
    const wanted = normalise(value);
    return SUBJECT_OPTIONS.some((option) => normalise(option) === wanted);
  };

  const deepestSubjectTextNodes = (root) => {
    return Array.from(root.querySelectorAll('*')).filter((element) => {
      if (!subjectTextMatches(element.textContent)) return false;
      return !Array.from(element.children).some((child) => subjectTextMatches(child.textContent));
    });
  };

  const subjectOptionNodes = (container) => {
    const roleOptions = Array.from(container.querySelectorAll('[role="option"]'))
      .filter((option) => subjectTextMatches(option.textContent));
    if (roleOptions.length) return roleOptions;
    return deepestSubjectTextNodes(container);
  };

  const subjectValueFor = (trigger, wrapper, shadow) => {
    const labelledIds = String(trigger.getAttribute('aria-labelledby') || '')
      .split(/\s+/)
      .filter(Boolean);
    for (const id of labelledIds) {
      const node = Array.from(shadow.querySelectorAll('[id]')).find((element) => element.id === id);
      if (!node || !trigger.contains(node)) continue;
      const match = SUBJECT_OPTIONS.find((option) => normalise(option) === normalise(node.textContent));
      if (match) return match;
    }

    const nativeSelects = Array.from(wrapper.querySelectorAll('select'));
    for (const select of nativeSelects) {
      const option = select.options?.[select.selectedIndex];
      const match = SUBJECT_OPTIONS.find((value) => normalise(value) === normalise(option?.textContent));
      if (match) return match;
    }

    const selectedOption = Array.from(shadow.querySelectorAll('[role="option"][aria-selected="true"]'))
      .find((option) => subjectTextMatches(option.textContent));
    if (selectedOption) {
      return SUBJECT_OPTIONS.find((option) => normalise(option) === normalise(selectedOption.textContent)) || '';
    }

    const triggerText = deepestSubjectTextNodes(trigger)[0]?.textContent;
    return SUBJECT_OPTIONS.find((option) => normalise(option) === normalise(triggerText)) || '';
  };

  const decorateSubject = (wrapper, control, shadow) => {
    const nativeSelects = Array.from(wrapper.querySelectorAll('select'));
    if (control.tagName === 'SELECT' && !nativeSelects.includes(control)) nativeSelects.push(control);
    nativeSelects.forEach((select) => select.classList.add('zv-native-subject-select'));

    const triggerCandidates = Array.from(wrapper.querySelectorAll([
      'button[aria-haspopup="listbox"]',
      'button[role="combobox"]',
      '[role="combobox"]:not(select):not(input)',
      'button[aria-expanded]:not([type="submit"])'
    ].join(',')));
    const trigger = triggerCandidates.sort((left, right) => {
      const score = (candidate) => {
        let value = 0;
        if (candidate.getAttribute('aria-haspopup') === 'listbox') value += 100;
        if (candidate.getAttribute('role') === 'combobox') value += 80;
        if (candidate.getAttribute('aria-labelledby')) value += 60;
        if (candidate.getAttribute('aria-controls')) value += 30;
        value += Math.min(candidate.getBoundingClientRect().width || 0, 500) / 100;
        return value;
      };
      return score(right) - score(left);
    })[0] || null;
    if (!trigger || trigger.closest('[data-zv-native-field="phone"]')) return;

    trigger.classList.add('zv-native-subject-trigger');
    const displayLabel = wrapper.querySelector(':scope > .zv-native-display-label[data-zv-label-for="subject"]');
    if (displayLabel) bindDisplayLabel(trigger, displayLabel);
    trigger.setAttribute('data-zv-subject-value', subjectValueFor(trigger, wrapper, shadow));
    triggerCandidates.forEach((candidate) => {
      if (candidate !== trigger) candidate.classList.add('zv-native-subject-auxiliary');
    });
    nativeSelects.forEach((select) => select.classList.add('zv-native-subject-select--backing'));
    deepestSubjectTextNodes(trigger).forEach((node) => node.classList.add('zv-native-subject-value'));
    trigger.querySelectorAll('svg, [aria-hidden="true"], [data-testid*="icon"], [data-testid*="arrow"], [data-testid*="chevron"], [data-testid*="caret"]')
      .forEach((icon) => {
        const testId = normalise(icon.getAttribute('data-testid'));
        const explicitIcon = icon.tagName === 'SVG' || /\b(icon|arrow|chevron|caret)\b/.test(testId);
        const hiddenEmptyLeaf = icon.getAttribute('aria-hidden') === 'true'
          && !subjectTextMatches(icon.textContent)
          && !Array.from(icon.children).some((child) => subjectTextMatches(child.textContent));
        if (explicitIcon || hiddenEmptyLeaf) icon.classList.add('zv-native-subject-native-arrow');
      });

    const controlledId = String(
      trigger.getAttribute('aria-controls') || trigger.getAttribute('aria-owns') || ''
    ).trim();
    let listbox = controlledId
      ? Array.from(shadow.querySelectorAll('[id]')).find((node) => node.id === controlledId)
      : null;

    if (!listbox || subjectOptionNodes(listbox).length < 3) {
      listbox = Array.from(shadow.querySelectorAll('[role="listbox"]'))
        .find((candidate) => subjectOptionNodes(candidate).length >= 3) || null;
    }
    if (!listbox) return;

    const listboxStyle = window.getComputedStyle(listbox);
    const listboxRect = listbox.getBoundingClientRect();
    const menuIsVisible = listboxRect.width > 1
      && listboxRect.height > 1
      && listboxStyle.display !== 'none'
      && listboxStyle.visibility !== 'hidden'
      && Number(listboxStyle.opacity || 1) > 0;
    const expandedState = trigger.getAttribute('aria-expanded');
    const menuIsOpen = expandedState == null ? menuIsVisible : expandedState === 'true';
    if (!menuIsOpen) return;

    listbox.classList.add('zv-native-subject-listbox');
    subjectOptionNodes(listbox).forEach((option) => option.classList.add('zv-native-subject-option'));

    let shell = listbox.parentElement;
    for (let depth = 0; shell && depth < 4; depth += 1) {
      if (shell.matches('form, section[data-testid="form-container"], #app-embed')) break;
      shell.classList.add('zv-native-subject-menu-shell');
      shell = shell.parentElement;
    }
  };

  let displayLabelSequence = 0;
  const originalLabelReferences = new WeakMap();

  const bindDisplayLabel = (control, displayLabel) => {
    if (!displayLabel.id) {
      const root = displayLabel.getRootNode();
      let nextId;
      do {
        nextId = `zv-native-contact-${FORM_ID}-label-${++displayLabelSequence}`;
      } while (root.getElementById(nextId));
      displayLabel.id = nextId;
    }
    displayLabel.removeAttribute('aria-hidden');
    if (!originalLabelReferences.has(control)) {
      originalLabelReferences.set(control, control.getAttribute('aria-labelledby'));
    }
    const root = control.getRootNode();
    const valueReferences = String(control.getAttribute('aria-labelledby') || '').split(/\s+/)
      .filter((id) => id && control.contains(root.getElementById(id)));
    const labelledBy = [displayLabel.id, ...valueReferences].join(' ');
    if (control.getAttribute('aria-labelledby') !== labelledBy) {
      control.setAttribute('aria-labelledby', labelledBy);
    }
    control.setAttribute('data-zv-native-labelledby', displayLabel.id);
  };

  const restoreNativeLabel = (control) => {
    const assignedId = control.getAttribute('data-zv-native-labelledby');
    if (String(control.getAttribute('aria-labelledby') || '').split(/\s+/)[0] === assignedId) {
      const original = originalLabelReferences.get(control);
      if (original == null) control.removeAttribute('aria-labelledby');
      else control.setAttribute('aria-labelledby', original);
    }
    originalLabelReferences.delete(control);
    control.removeAttribute('data-zv-native-labelledby');
  };

  const decorateFieldLabel = (wrapper, candidate, key, outer) => {
    const control = candidate.control;
    const required = MANDATORY_FIELDS.has(key)
      || control.required
      || control.getAttribute('aria-required') === 'true';
    if (MANDATORY_FIELDS.has(key) && ['INPUT', 'TEXTAREA', 'SELECT'].includes(control.tagName)) {
      control.required = true;
      control.setAttribute('aria-required', 'true');
    }
    const controlId = control.getAttribute('id');
    const wrapperLabels = Array.from(wrapper.querySelectorAll('label')).filter((label) => {
      const forId = label.getAttribute('for');
      return label.contains(control)
        || (controlId && forId === controlId)
        || semanticKeyFor(normalise(label.textContent), control) === key;
    });
    const fieldLabels = unique([...candidate.labels, ...wrapperLabels])
      .filter((label) => !label.classList.contains('zv-native-display-label'));
    const wrappingLabel = fieldLabels.find((label) => label.tagName === 'LABEL' && label.contains(control));

    fieldLabels.forEach((label) => {
      label.classList.remove(
        'zv-native-label',
        'zv-native-label--required',
        'zv-native-label--wraps-control',
        'zv-native-source-label',
        'zv-native-source-label--wraps-control'
      );
      label.classList.add(
        label === wrappingLabel ? 'zv-native-source-label--wraps-control' : 'zv-native-source-label'
      );
    });

    let displayLabel = wrapper.querySelector(`:scope > .zv-native-display-label[data-zv-label-for="${key}"]`);
    if (!displayLabel) {
      displayLabel = wrapper.ownerDocument.createElement('span');
      displayLabel.className = 'zv-native-display-label';
      displayLabel.setAttribute('data-zv-label-for', key);
      wrapper.insertBefore(displayLabel, wrapper.firstChild);
    }
    const labelText = copyFromOuter(outer, `label-${key}`, DISPLAY_FIELD_LABELS[key]);
    if (displayLabel.textContent !== labelText) displayLabel.textContent = labelText;
    displayLabel.classList.toggle('zv-native-display-label--required', required);
    bindDisplayLabel(control, displayLabel);
    markNativeCaptionText(wrapper, key, outer);
  };

  const decorateSuccess = (success, outer) => {
    success.classList.add('zv-native-success-banner');
    success.closest('#app-embed')?.classList.add('zv-native-success-container');
    success.closest('section[data-testid="form-container"]')?.classList.add('zv-native-success-container');
    if (!success.hasAttribute('role') && !success.hasAttribute('aria-live')) {
      success.setAttribute('role', 'status');
      success.setAttribute('aria-live', 'polite');
      success.setAttribute('aria-atomic', 'true');
    }

    const existingPanel = Array.from(success.children)
      .find((child) => child.hasAttribute('data-zv-native-success-panel'));
    Array.from(success.children).forEach((child) => {
      if (child !== existingPanel) child.classList.add('zv-native-success-original');
    });
    if (existingPanel) return existingPanel;

    const doc = success.ownerDocument || document;
    const panel = doc.createElement('div');
    panel.setAttribute('data-zv-native-success-panel', '');

    const icon = doc.createElement('span');
    icon.className = 'zv-native-success-icon';
    icon.setAttribute('aria-hidden', 'true');
    const iconSvg = doc.createElementNS('http://www.w3.org/2000/svg', 'svg');
    iconSvg.setAttribute('viewBox', '0 0 24 24');
    iconSvg.setAttribute('width', '22');
    iconSvg.setAttribute('height', '22');
    iconSvg.setAttribute('fill', 'none');
    iconSvg.setAttribute('stroke', 'currentColor');
    iconSvg.setAttribute('stroke-width', '2.8');
    iconSvg.setAttribute('stroke-linecap', 'round');
    iconSvg.setAttribute('stroke-linejoin', 'round');
    iconSvg.setAttribute('focusable', 'false');
    const iconPath = doc.createElementNS('http://www.w3.org/2000/svg', 'path');
    iconPath.setAttribute('d', 'm5 12 4 4L19 6');
    iconSvg.appendChild(iconPath);
    icon.appendChild(iconSvg);

    const copy = doc.createElement('div');
    copy.className = 'zv-native-success-copy';

    const heading = doc.createElement('h3');
    heading.className = 'zv-native-success-heading';
    heading.textContent = copyFromOuter(outer, 'success-heading', window.ZinVoltI18n.t("thank_you_your_message_has_been_sent_b5d5cf"));

    const text = doc.createElement('p');
    text.className = 'zv-native-success-text';
    text.textContent = copyFromOuter(
      outer,
      'success-text',
      window.ZinVoltI18n.t("we_have_received_your_question_and_usually_74d1cb")
    );

    const actions = doc.createElement('div');
    actions.className = 'zv-native-success-actions';

    const retryLink = doc.createElement('a');
    retryLink.className = 'zv-native-success-link zv-native-success-link--primary';
    retryLink.href = copyFromOuter(outer, 'success-retry-url', window.location.pathname);
    retryLink.textContent = copyFromOuter(outer, 'success-retry-label', window.ZinVoltI18n.t("ask_another_question_5da02b"));

    const homeLink = doc.createElement('a');
    homeLink.className = 'zv-native-success-link';
    homeLink.href = window.ZinVoltI18n.url(copyFromOuter(outer, 'success-home-url', '/'));
    homeLink.textContent = copyFromOuter(outer, 'success-home-label', window.ZinVoltI18n.t("go_back_to_the_homepage_0103b1"));

    copy.append(heading, text);
    actions.append(retryLink, homeLink);
    panel.append(icon, copy, actions);
    success.appendChild(panel);
    return panel;
  };

  const labelsFor = (control, form) => {
    const labels = [];

    if (control.labels) {
      labels.push(...Array.from(control.labels));
    }

    const controlId = control.getAttribute('id');
    if (controlId) {
      form.querySelectorAll('label[for]').forEach((label) => {
        if (label.getAttribute('for') === controlId) labels.push(label);
      });
    }

    const wrappingLabel = control.closest('label');
    if (wrappingLabel) labels.push(wrappingLabel);

    const labelledBy = String(control.getAttribute('aria-labelledby') || '').trim();
    if (labelledBy) {
      labelledBy.split(/\s+/).forEach((id) => {
        const labelledElement = form.querySelector(`[id="${id.replace(/"/g, '\\"')}"]`);
        // Shopify dropdowns use aria-labelledby for both the actual field
        // label and a live value span inside the button. The latter is not a
        // label: hiding it is exactly what made selected Onderwerp values
        // disappear in v54.
        if (labelledElement && !control.contains(labelledElement)) labels.push(labelledElement);
      });
    }

    return unique(labels);
  };

  const descriptorFor = (control, form) => {
    const ownValues = [
      control.getAttribute('data-testid'),
      control.getAttribute('name'),
      control.getAttribute('id'),
      control.getAttribute('type'),
      control.getAttribute('autocomplete'),
      control.getAttribute('aria-label'),
      control.getAttribute('placeholder')
    ];
    const labelValues = labelsFor(control, form).map((label) => label.textContent);
    return normalise([...ownValues, ...labelValues].join(' '));
  };

  const semanticKeyFor = (descriptor, control) => {
    if (/\b(e mail(?:adres)?|email(?:adres|address)?)\b/.test(descriptor)) return 'email';
    if (/\b(telefoon(?:nummer)?|phone(?: number)?|tel)\b/.test(descriptor)) return 'phone';
    if (/\b(onderwerp|subject)\b/.test(descriptor)) return 'subject';
    if (/\b(ordernummer|serienummer|order number|serial number)\b/.test(descriptor)) return 'order';
    if (/\b(bericht|message|vraag)\b/.test(descriptor) || control.tagName === 'TEXTAREA') return 'message';
    if (/\b(first name|firstname|voornaam|naam|name)\b/.test(descriptor)) return 'name';
    return '';
  };

  const candidateScore = (control, key, descriptor, labels) => {
    let score = 0;
    const ownIdentity = normalise([
      control.getAttribute('data-testid'),
      control.getAttribute('name'),
      control.getAttribute('id'),
      control.getAttribute('autocomplete')
    ].join(' '));
    const labelText = normalise(labels.map((label) => label.textContent).join(' '));
    const isHidden = control.tagName === 'INPUT' && String(control.type).toLowerCase() === 'hidden';

    if (!isHidden) score += 50;
    if (semanticKeyFor(ownIdentity, control) === key) score += 100;
    if (semanticKeyFor(labelText, control) === key) score += 60;
    if (descriptor.includes(key)) score += 10;
    if (key === 'message' && control.tagName === 'TEXTAREA') score += 30;
    if (key === 'subject' && control.tagName === 'SELECT') score += 30;
    if (key === 'subject' && (control.getAttribute('role') === 'combobox' || control.matches('button[aria-expanded]'))) score += 20;
    if (key === 'email' && String(control.type).toLowerCase() === 'email') score += 30;
    if (key === 'phone' && String(control.type).toLowerCase() === 'tel') score += 30;
    return score;
  };

  const fieldWrapperFor = (control, form, primaryControls) => {
    let node = control;
    let candidate = control.parentElement;

    while (node.parentElement && node.parentElement !== form) {
      const parent = node.parentElement;
      const containedControls = primaryControls.filter((item) => parent.contains(item));
      if (containedControls.length !== 1) break;
      candidate = parent;
      node = parent;
    }

    return candidate && form.contains(candidate) ? candidate : control.parentElement;
  };

  const lowestCommonAncestor = (nodes, boundary) => {
    if (!nodes.length) return null;
    let candidate = nodes[0];

    while (candidate && boundary.contains(candidate)) {
      if (nodes.every((node) => candidate.contains(node))) return candidate;
      if (candidate === boundary) break;
      candidate = candidate.parentElement;
    }

    return boundary;
  };

  const markGridPaths = (wrappers, grid) => {
    wrappers.forEach((wrapper) => {
      let parent = wrapper.parentElement;
      while (parent && parent !== grid) {
        parent.classList.add('zv-native-grid-contents');
        parent = parent.parentElement;
      }
    });
  };

  const submitWrapperFor = (button, form, primaryControls) => {
    let node = button;
    let candidate = button;

    while (node.parentElement && node.parentElement !== form) {
      const parent = node.parentElement;
      if (primaryControls.some((control) => parent.contains(control))) break;
      if (parent.querySelectorAll('button[type="submit"], button[data-testid="btn-form-submit"]').length !== 1) break;
      candidate = parent;
      node = parent;
    }

    return candidate;
  };

  const markPhoneRow = (wrapper, control) => {
    const countryButton = wrapper.querySelector('button[aria-expanded]');
    if (!countryButton) return;

    let row = control.parentElement;
    while (row && row !== wrapper && !row.contains(countryButton)) {
      row = row.parentElement;
    }

    if (!row || !row.contains(control) || !row.contains(countryButton)) return;

    const inputSlot = topLevelBranch(control, row);
    const countrySlot = topLevelBranch(countryButton, row);
    if (!inputSlot || !countrySlot || inputSlot === countrySlot) return;

    inputSlot.classList.add('zv-native-phone-input-slot');
    countrySlot.classList.add('zv-native-phone-country-slot');
    if (row === wrapper) wrapper.classList.add('zv-native-phone-field-direct');
    else row.classList.add('zv-native-phone-row');
  };

  const resetFormPresentation = (shadow, activeWrappers) => {
    const active = new Set(activeWrappers);

    shadow.querySelectorAll('.zv-native-contact-form').forEach((node) => node.classList.remove('zv-native-contact-form'));
    shadow.querySelectorAll('.zv-native-field').forEach((node) => {
      node.classList.remove('zv-native-field', 'zv-native-phone-field-direct');
      node.removeAttribute('data-zv-native-field');
    });
    shadow.querySelectorAll('.zv-native-grid').forEach((node) => node.classList.remove('zv-native-grid'));
    shadow.querySelectorAll('.zv-native-grid-contents').forEach((node) => node.classList.remove('zv-native-grid-contents'));
    shadow.querySelectorAll('.zv-native-grid-utility').forEach((node) => node.classList.remove('zv-native-grid-utility'));
    shadow.querySelectorAll('.zv-native-phone-row').forEach((node) => node.classList.remove('zv-native-phone-row'));
    shadow.querySelectorAll('.zv-native-phone-input-slot').forEach((node) => node.classList.remove('zv-native-phone-input-slot'));
    shadow.querySelectorAll('.zv-native-phone-country-slot').forEach((node) => node.classList.remove('zv-native-phone-country-slot'));
    shadow.querySelectorAll('.zv-native-control-path').forEach((node) => node.classList.remove('zv-native-control-path'));
    shadow.querySelectorAll('.zv-native-caption-container').forEach((node) => node.classList.remove('zv-native-caption-container'));
    shadow.querySelectorAll('.zv-native-subject-trigger').forEach((node) => node.classList.remove('zv-native-subject-trigger'));
    shadow.querySelectorAll('.zv-native-subject-trigger').forEach((node) => node.removeAttribute('data-zv-subject-value'));
    shadow.querySelectorAll('.zv-native-subject-select').forEach((node) => node.classList.remove('zv-native-subject-select'));
    shadow.querySelectorAll('.zv-native-subject-select--backing').forEach((node) => node.classList.remove('zv-native-subject-select--backing'));
    shadow.querySelectorAll('.zv-native-subject-auxiliary').forEach((node) => node.classList.remove('zv-native-subject-auxiliary'));
    shadow.querySelectorAll('.zv-native-subject-value').forEach((node) => node.classList.remove('zv-native-subject-value'));
    shadow.querySelectorAll('.zv-native-subject-native-arrow').forEach((node) => node.classList.remove('zv-native-subject-native-arrow'));
    shadow.querySelectorAll('.zv-native-subject-listbox').forEach((node) => node.classList.remove('zv-native-subject-listbox'));
    shadow.querySelectorAll('.zv-native-subject-option').forEach((node) => node.classList.remove('zv-native-subject-option'));
    shadow.querySelectorAll('.zv-native-subject-menu-shell').forEach((node) => node.classList.remove('zv-native-subject-menu-shell'));
    shadow.querySelectorAll('.zv-native-submit-row').forEach((node) => node.classList.remove('zv-native-submit-row'));
    shadow.querySelectorAll('.zv-native-submit-button').forEach((node) => node.classList.remove('zv-native-submit-button'));
    shadow.querySelectorAll('.zv-native-form-title').forEach((node) => node.classList.remove('zv-native-form-title'));
    shadow.querySelectorAll('.zv-native-label, .zv-native-source-label, .zv-native-source-label--wraps-control')
      .forEach((node) => node.classList.remove(
        'zv-native-label',
        'zv-native-label--required',
        'zv-native-label--wraps-control',
        'zv-native-source-label',
        'zv-native-source-label--wraps-control'
      ));
    shadow.querySelectorAll('.zv-native-display-label').forEach((label) => {
      if (!active.has(label.parentElement)) {
        label.parentElement.querySelectorAll('[data-zv-native-labelledby]').forEach(restoreNativeLabel);
        label.remove();
      }
    });
  };

  const installStyle = (shadow) => {
    if (shadow.getElementById(STYLE_ID)) return;
    const style = document.createElement('style');
    style.id = STYLE_ID;
    style.textContent = SHADOW_CSS;
    shadow.appendChild(style);
  };

  const decorateShadow = (shadow, host) => {
    installStyle(shadow);

    const outer = host.closest('.zv-contact-native-form');
    const form = shadow.querySelector('form[data-testid="form"], form');
    const success = shadow.querySelector('[data-testid="banner-success"]');
    const successStyle = success ? window.getComputedStyle(success) : null;
    const successVisible = Boolean(
      success &&
      !success.hidden &&
      success.getAttribute('aria-hidden') !== 'true' &&
      successStyle &&
      successStyle.display !== 'none' &&
      successStyle.visibility !== 'hidden' &&
      success.getClientRects().length > 0
    );

    if (successVisible) {
      decorateSuccess(success, outer);
      if (outer) {
        outer.classList.remove('is-zv-native-enhanced');
        outer.classList.add('is-zv-native-success');
      }
      return true;
    }

    if (!form) {
      if (outer) {
        outer.classList.remove('is-zv-native-enhanced');
        outer.classList.toggle('is-zv-native-success', successVisible);
      }
      return false;
    }

    if (outer) outer.classList.remove('is-zv-native-success');
    const primaryControls = Array.from(form.querySelectorAll(PRIMARY_CONTROL_SELECTOR));
    const secondaryControls = Array.from(form.querySelectorAll(SECONDARY_CONTROL_SELECTOR))
      .filter((control) => !primaryControls.includes(control));
    const allControls = [...primaryControls, ...secondaryControls];
    markTechnicalFields(form, allControls);

    const candidates = allControls.map((control) => {
      const labels = labelsFor(control, form);
      const descriptor = descriptorFor(control, form);
      const key = semanticKeyFor(descriptor, control);
      return {
        control,
        labels,
        descriptor,
        key,
        score: key ? candidateScore(control, key, descriptor, labels) : 0
      };
    }).filter((candidate) => candidate.key);

    const selected = new Map();
    candidates.forEach((candidate) => {
      const current = selected.get(candidate.key);
      if (!current || candidate.score > current.score) selected.set(candidate.key, candidate);
    });

    const mappedControls = Array.from(selected.values()).map((candidate) => candidate.control);
    const entries = [];
    selected.forEach((candidate, key) => {
      const wrapper = fieldWrapperFor(candidate.control, form, mappedControls);
      if (!wrapper) return;
      entries.push({ candidate, key, wrapper });
    });

    const uniqueWrappers = unique(entries.map(({ wrapper }) => wrapper));
    const grid = lowestCommonAncestor(uniqueWrappers, form);
    const submitButton = form.querySelector('button[data-testid="btn-form-submit"], button[type="submit"]');
    const ready = REQUIRED_FIELDS.every((key) => selected.has(key))
      && entries.length === REQUIRED_FIELDS.length
      && uniqueWrappers.length === REQUIRED_FIELDS.length
      && Boolean(grid && submitButton);

    if (!ready) {
      resetFormPresentation(shadow, []);
      if (outer) outer.classList.remove('is-zv-native-enhanced');
      return false;
    }

    resetFormPresentation(shadow, uniqueWrappers);
    markTechnicalFields(form, allControls);
    form.classList.add('zv-native-contact-form');

    const title = Array.from(shadow.querySelectorAll('h1, h2, h3'))
      .find((heading) => normalise(heading.textContent) === 'contact');
    if (title) title.classList.add('zv-native-form-title');

    entries.forEach(({ candidate, key, wrapper }) => {

      wrapper.classList.add('zv-native-field');
      wrapper.setAttribute('data-zv-native-field', key);

      decorateFieldLabel(wrapper, candidate, key, outer);
      markControlPath(wrapper, candidate.control);

      const placeholder = copyFromOuter(outer, `placeholder-${key}`, key === 'message' ? window.ZinVoltI18n.t("briefly_explain_how_we_can_help_you_582c2e") : PLACEHOLDERS[key]);
      if (placeholder && ['INPUT', 'TEXTAREA'].includes(candidate.control.tagName)) {
        candidate.control.setAttribute('placeholder', placeholder);
      }

      if (key === 'phone') markPhoneRow(wrapper, candidate.control);
      if (key === 'subject') decorateSubject(wrapper, candidate.control, shadow);
    });

    grid.classList.add('zv-native-grid');
    markGridPaths(uniqueWrappers, grid);
    markGridUtilities(grid);

    submitButton.classList.add('zv-native-submit-button');
    submitWrapperFor(submitButton, form, mappedControls).classList.add('zv-native-submit-row');

    if (outer) outer.classList.add('is-zv-native-enhanced');
    return true;
  };

  const attach = (host) => {
    const shadow = host.shadowRoot;
    if (!shadow) return false;

    decorateShadow(shadow, host);
    if (!shadowObservers.has(shadow)) {
      let refreshFrame = 0;
      const refreshPresentation = () => {
        if (refreshFrame) return;
        refreshFrame = window.requestAnimationFrame(() => {
          refreshFrame = 0;
          decorateShadow(shadow, host);
        });
      };
      const observer = new MutationObserver(refreshPresentation);
      observer.observe(shadow, {
        attributes: true,
        attributeFilter: ['aria-expanded', 'aria-selected', 'hidden', 'style'],
        childList: true,
        characterData: true,
        subtree: true
      });
      shadow.addEventListener('click', refreshPresentation);
      shadow.addEventListener('change', refreshPresentation);
      shadowObservers.set(shadow, observer);
    }
    return true;
  };

  const scan = () => {
    scanFrame = 0;
    let waitingForHydration = false;

    document.querySelectorAll(ROOT_SELECTOR).forEach((root) => {
      const hosts = [];
      if (root.matches(EMBED_SELECTOR)) hosts.push(root);
      hosts.push(...root.querySelectorAll(EMBED_SELECTOR));

      if (!hosts.length) waitingForHydration = true;
      hosts.forEach((host) => {
        if (!attach(host)) waitingForHydration = true;
      });
    });

    if (waitingForHydration && Date.now() < pollDeadline && !pollTimer) {
      pollTimer = window.setTimeout(() => {
        pollTimer = 0;
        scheduleScan();
      }, 120);
    }
  };

  const scheduleScan = () => {
    if (scanFrame) return;
    scanFrame = window.requestAnimationFrame(scan);
  };

  const startHydrationWindow = () => {
    pollDeadline = Date.now() + 15000;
    scheduleScan();
  };

  if (!window.ZinVoltNativeContactStyle) {
    window.ZinVoltNativeContactStyle = { refresh: startHydrationWindow };
    documentObserver = new MutationObserver(scheduleScan);
    documentObserver.observe(document.documentElement, { childList: true, subtree: true });
    document.addEventListener('shopify:section:load', startHydrationWindow);

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', startHydrationWindow, { once: true });
    } else {
      startHydrationWindow();
    }
  }
})();
